<script lang="ts" setup>
import { computed, useAttrs } from 'vue';

const attrs = useAttrs();
const greyColor = computed(() => {
  const keys = Object.keys(attrs);
  return keys.filter(key => key.startsWith('bg-')).length > 0
    ? 'base-tag'
    : 'base-tag bg-gray-500';
});
</script>

<template>
  <span
    :class="greyColor"
    inline-block
    break-keep
    rounded
    p-1
    px-4
    text-center
    color-light-50
  >
    <slot />
  </span>
</template>

<style>
.base-tag {
  white-space: nowrap;
}
</style>
